var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.438 12.566c0-6.04-4.898-10.938-10.938-10.938-6.04 0-10.938 4.898-10.938 10.938 0 5.459 4 9.984 9.229 10.805V15.73H8.013v-3.163h2.778v-2.41c0-2.74 1.633-4.256 4.131-4.256 1.197 0 2.45.214 2.45.214v2.692h-1.38c-1.359 0-1.784.843-1.784 1.71v2.05h3.034l-.485 3.162H14.21v7.644c5.23-.82 9.229-5.346 9.229-10.806z",
    fill: "#000"
  })));
}
export default SvgIconFb;